'use strict';

exports.__esModule = true;
exports.replaceUrlQueryFromAction = replaceUrlQueryFromAction;
exports.pushUrlQueryFromAction = pushUrlQueryFromAction;
exports.replaceInUrlQueryFromAction = replaceInUrlQueryFromAction;
exports.pushInUrlQueryFromAction = pushInUrlQueryFromAction;
exports.multiReplaceInUrlQueryFromAction = multiReplaceInUrlQueryFromAction;
exports.multiPushInUrlQueryFromAction = multiPushInUrlQueryFromAction;

var _updateUrlQuery = require('../updateUrlQuery');

function replaceUrlQueryFromAction(action, location) {
  var encodedQuery = action.payload.encodedQuery;

  (0, _updateUrlQuery.replaceUrlQuery)(encodedQuery, location);
}

function pushUrlQueryFromAction(action, location) {
  var encodedQuery = action.payload.encodedQuery;

  (0, _updateUrlQuery.pushUrlQuery)(encodedQuery, location);
}

function replaceInUrlQueryFromAction(action, location) {
  var _action$payload = action.payload;
  var queryParam = _action$payload.queryParam;
  var encodedValue = _action$payload.encodedValue;

  (0, _updateUrlQuery.replaceInUrlQuery)(queryParam, encodedValue, location);
}

function pushInUrlQueryFromAction(action, location) {
  var _action$payload2 = action.payload;
  var queryParam = _action$payload2.queryParam;
  var encodedValue = _action$payload2.encodedValue;

  (0, _updateUrlQuery.pushInUrlQuery)(queryParam, encodedValue, location);
}

function multiReplaceInUrlQueryFromAction(action, location) {
  var encodedQuery = action.payload.encodedQuery;

  (0, _updateUrlQuery.multiReplaceInUrlQuery)(encodedQuery, location);
}

function multiPushInUrlQueryFromAction(action, location) {
  var encodedQuery = action.payload.encodedQuery;

  (0, _updateUrlQuery.multiPushInUrlQuery)(encodedQuery, location);
}


//////////////////
// WEBPACK FOOTER
// ./~/react-url-query/lib/redux/updateUrlQueryFromAction.js
// module id = 56
// module chunks = 131683993344931 142807904292071 231608221292675